/* unplugin-vue-components disabled */import script from "./alarmRealTime.vue?vue&type=script&setup=true&lang=js"
export * from "./alarmRealTime.vue?vue&type=script&setup=true&lang=js"

import "./alarmRealTime.vue?vue&type=style&index=0&id=86a3756c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86a3756c"]])

export default __exports__